import { accountStorageKey, accountUsername } from "./accountStorage.js";
/**
 * Match paired IMAP usernames with mailbox identity hints.
 * Supports bare usernames (markham) vs full addresses (markham@example.com),
 * and exact full-email matches for Kerio accounts.
 */
export function accountsMatch(a, b) {
    const left = a.trim().toLowerCase();
    const right = b.trim().toLowerCase();
    if (left === right) {
        return true;
    }
    const leftHasAt = left.includes("@");
    const rightHasAt = right.includes("@");
    // Two full addresses only match when identical (already handled above).
    // Do not treat support@a.com and support@b.com as the same account.
    if (leftHasAt && rightHasAt) {
        return false;
    }
    // Bare username may match the local-part of a full address (legacy Dovecot pairing).
    return accountUsername(left) === accountUsername(right);
}
export function matchPairedAccount(mailboxCandidates, pairedAccounts, aliasesByAccount = {}) {
    // Prefer exact full-email matches first (Kerio / multi-domain).
    for (const candidate of mailboxCandidates) {
        const normalized = candidate.trim().toLowerCase();
        if (!normalized.includes("@")) {
            continue;
        }
        for (const paired of pairedAccounts) {
            if (accountStorageKey(paired) === normalized) {
                return paired;
            }
            for (const alias of aliasesByAccount[paired] ?? []) {
                if (accountStorageKey(alias) === normalized) {
                    return paired;
                }
            }
        }
    }
    for (const candidate of mailboxCandidates) {
        for (const paired of pairedAccounts) {
            if (accountsMatch(candidate, paired)) {
                return paired;
            }
            for (const alias of aliasesByAccount[paired] ?? []) {
                if (accountsMatch(candidate, alias)) {
                    return paired;
                }
            }
        }
    }
    return null;
}
